export default __webpack_public_path__ + "static/media/blc_view.ccce2345.JPG";